import { Typography } from 'antd';
import { FC } from 'react';

import { IStatusLegendItem } from '../../../types';

const { Text } = Typography;

export const StatusLegend: FC<{
  items: IStatusLegendItem[];
  fontSize?: number;
  marginTop?: number;
}> = ({ items, fontSize = 10, marginTop = 6 }) => (
  <div
    style={{
      display: 'flex',
      gap: 12,
      marginTop,
      justifyContent: 'center',
      flexWrap: 'wrap',
    }}
  >
    {items.map((item) => (
      <Text key={item.label} style={{ color: item.color, fontSize }}>
        {item.label}
      </Text>
    ))}
  </div>
);
